import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const MobileNav = ({ userRole = 'artist' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, openLoginModal } = useAuth();

  const navigationItems = [
    {
      label: 'Keşfet',
      path: '/',
      icon: 'Search',
      requiresAuth: false
    },
    {
      label: 'Kampanyalar',
      path: '/campaign-management',
      icon: 'Briefcase',
      requiresAuth: false
    },
    {
      label: 'Mesajlar',
      path: '/messages',
      icon: 'MessageSquare',
      requiresAuth: true
    },
    {
      label: 'Dashboard',
      path: userRole === 'artist' ? '/artist-dashboard' : '/influencer-dashboard',
      icon: 'LayoutDashboard',
      requiresAuth: true
    }
  ];

  const isActive = (path) => {
    return location?.pathname === path;
  };

  const handleNavigation = (item) => {
    if (item?.requiresAuth && !user) {
      openLoginModal();
      return;
    }
    navigate(item?.path);
  };

  return (
    <nav 
      className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-card border-t border-border z-[1000]"
      role="navigation"
      aria-label="Mobile navigation"
    >
      <div className="h-full flex items-center justify-around px-2">
        {navigationItems?.map((item) => (
          <button
            key={item?.path}
            onClick={() => handleNavigation(item)}
            className={`
              flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-md
              transition-smooth min-w-[64px]
              ${isActive(item?.path) 
                ? 'text-primary' :'text-muted-foreground'
              }
            `}
            aria-current={isActive(item?.path) ? 'page' : undefined}
            aria-label={item?.label}
          >
            <Icon 
              name={item?.icon} 
              size={20}
              color={isActive(item?.path) ? 'var(--color-primary)' : 'currentColor'}
            />
            <span className="text-xs font-medium">{item?.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileNav;